import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime';
export const IconClose = (props) =>
  _jsxs('svg', {
    viewBox: '0 0 24 24',
    fill: 'none',
    ...props,
    children: [
      _jsx('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M17.707 6.293a1 1 0 0 1 0 1.414l-10 10a1 1 0 0 1-1.414-1.414l10-10a1 1 0 0 1 1.414 0Z',
        fill: 'currentColor',
      }),
      _jsx('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M6.293 6.293a1 1 0 0 1 1.414 0l10 10a1 1 0 0 1-1.414 1.414l-10-10a1 1 0 0 1 0-1.414Z',
        fill: 'currentColor',
      }),
    ],
  });
IconClose.displayName = 'IconClose';
